module.exports = __webpack_public_path__ + "static/media/up-arrow-svgrepo-com (13).9742a8ce.svg";